import React from 'react';
import { BrowserRouter, Routes, Route, Link, useSearchParams } from 'react-router-dom';
import './App.css';
import AdminPage from './pages/AdminPage';
import PublicPage from './pages/PublicPage';
import RaffleDetailPage from './pages/RaffleDetailPage';
import LiveRafflePage from './pages/LiveRafflePage';
import PresentPage from './pages/PresentPage';
import AdminAuth from './components/AdminAuth';
import Footer from './components/Footer';
import RaffleEntryForm from './components/RaffleEntryForm';
import AboutPage from './pages/AboutPage';

function HomePage() {
  const [searchParams] = useSearchParams();
  const initialCode = searchParams.get('code') || undefined;

  return (
    <div className="home-page">
      <div className="home-login">
        <Link to="/admin" className="home-login-btn">
          Login
        </Link>
      </div>

      <div className="hero">
        <img src="/logos/patchmypc-hero.png" alt="Patch My PC Logo" className="hero-logo" />
        <h1>Patch My PC Giveaway</h1>
        <p className="hero-subtitle">
          Welcome to the Patch My PC Giveaway website. Enter your raffle code below
          or explore our products and community initiatives.
        </p>
      </div>

      <div className="home-entry-section">
        <h2>Enter a Raffle</h2>
        <RaffleEntryForm initialCode={initialCode} />
      </div>

      <div className="home-cards">
        <a href="https://psappdeploytoolkit.com" target="_blank" rel="noopener noreferrer" className="home-card">
          <img src="/logos/psadt.svg" alt="PSADT" className="home-card-logo" />
          <h2>PSADT</h2>
          <p>The PowerShell App Deployment Toolkit for enterprise deployments</p>
        </a>
        <a href="https://patchmypc.com" target="_blank" rel="noopener noreferrer" className="home-card home-card--featured">
          <img src="/logos/patchmypc.png" alt="Patch My PC" className="home-card-logo" />
          <h2>Patch My PC</h2>
          <p>Simplify third-party application patching for SCCM and Intune</p>
        </a>
        <Link to="/about" className="home-card">
          <img src="/logos/about.svg" alt="About This" className="home-card-logo" />
          <h2>About This</h2>
          <p>Learn about the AI Prize Wheel project and how it was built</p>
        </Link>
      </div>

    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminAuth><AdminPage /></AdminAuth>} />
          <Route path="/admin/raffle/:id" element={<AdminAuth><RaffleDetailPage /></AdminAuth>} />
          <Route path="/admin/raffle/:id/present" element={<AdminAuth><PresentPage /></AdminAuth>} />
          <Route path="/join" element={<PublicPage />} />
          <Route path="/live/:id" element={<LiveRafflePage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
